import { atom } from "recoil";

const registerWaterInTakePopUpAtom = atom({
  key: "registerWaterInTakePopUp",
  default: false,
});

export default registerWaterInTakePopUpAtom;
